import type { ReactElement } from 'react'

import './styles.scss'

const YesterdayDate = (): ReactElement => {
  return (
    <span className="yesterday-label-container">
      Yesterday<span className="yesterday-label-data">&rsquo;s data</span>
    </span>
  )
}

export default YesterdayDate
